import { IMapComponent } from "@components/map/map.models";
import { IMapDrawLayer, IMapGeometry, IMapGeometryPoint, IMapSettings } from "@components/map/map.settings";
import { ITplDestineringRuttQueryResult } from "../../../../models/queries";
import { TplTransportavstandKartaLayers } from "./tpl-transportavstand-karta.layers";

export class TplTransportavstandKartaSlutpunkt extends TplTransportavstandKartaLayers {

    load(data: ITplDestineringRuttQueryResult, mapsettings: IMapSettings, map: IMapComponent) {
        const geometries = data.slutPunkt ? [
            {
                id: "slutpunkt",
                label: "Slutpunkt",
                easting: data.slutPunkt.easting,
                northing: data.slutPunkt.northing,
                iconid: "slutpunktIcon",
                visible: true
            } as IMapGeometryPoint
        ] : [];

        mapsettings.drawLayers.find(x => x.id === "slutpunkt").geometries = geometries;
        map.refreshGeometries("slutpunkt");
    }

    getLayer() {
        return {
            id: "slutpunkt",
            title: "Slutpunkt",
            showGeometriesMenu: false,
            visible: true,
            readonly: true,
            autoZoom: true,
            zoomable: true,
            geometries: [],
            selectable: false,
            hideInLayerList: true,
            onHoverIn: (geom: IMapGeometry, mouseevent: any) => this.hoverIn(geom, mouseevent),
            onHoverOut: (geom: IMapGeometry, mouseevent: any) => this.hoverOut(geom, mouseevent),
            drawOptions: [
                {
                    title: ``,
                    type: "point",
                    callback: (g) => {
                        // Kräver callback
                    },
                    onBeforeDraw: () => true
                }
            ]
        } as IMapDrawLayer;
    }
}
